// Function to pause all videos except the current one
function pauseAllVideosExcept(currentVideo) {
  document.querySelectorAll('.video-wrapper video, .astra-gallery__video').forEach(video => {
    if (video !== currentVideo && !video.paused) {
      video.pause();
      const wrapper = video.closest('.video-wrapper') || video.closest('.astra-gallery__video-wrapper');
      if (wrapper) {
      wrapper.classList.remove('playing');
      }
      
      // For gallery videos, show overlay when paused
      const overlay = video.closest('.astra-gallery__item')?.querySelector('.astra-gallery__video-overlay');
      if (overlay) {
        overlay.style.opacity = '1';
        overlay.style.pointerEvents = 'all';
      }
    }
  });
}

// Fix iOS video poster/thumbnail display by briefly playing and pausing
function fixIOSVideoPosters() {
  // Check if iOS
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  
  if (isIOS) {
    const videos = document.querySelectorAll('.video-wrapper video, .astra-gallery__video');
    let processedCount = 0;
    
    videos.forEach((video, index) => {
      // Stagger the play/pause to avoid all videos loading at once
      setTimeout(() => {
        // Ensure video is muted during thumbnail generation
        const wasMuted = video.muted;
        video.muted = true;
        
        // Set currentTime to 0 to ensure we're at the start
        video.currentTime = 0;
        
        // Load the video metadata first
        video.load();
        
        // Wait for metadata to load, then play briefly
        const showThumbnail = function() {
          if (video.readyState >= 2) { // HAVE_CURRENT_DATA
            // Play for a split second to generate thumbnail
            video.play().then(() => {
              // Immediately pause after a very brief moment
              setTimeout(() => {
                video.pause();
                video.currentTime = 0;
                video.muted = wasMuted; // Restore original muted state
                
                processedCount++;
                if (processedCount === videos.length) {
                  console.log('iOS video thumbnails loaded');
                }
              }, 100); // Play for 100ms
            }).catch(() => {
              // If play fails, just restore muted state
              video.muted = wasMuted;
            });
          } else {
            // If metadata not ready, try again after a short delay
            setTimeout(showThumbnail, 200);
          }
        };
        
        // Try to show thumbnail when metadata is loaded
        if (video.readyState >= 2) {
          showThumbnail();
        } else {
          video.addEventListener('loadedmetadata', showThumbnail, { once: true });
          // Fallback timeout
          setTimeout(showThumbnail, 1000);
        }
      }, index * 200); // Stagger each video by 200ms
    });
  }
}

// Handle play button clicks for all videos
document.addEventListener('DOMContentLoaded', function() {
    // Fix iOS video posters - DISABLED: We now use proper thumbnails from assets/thumbnails-gallery
    // fixIOSVideoPosters();
    
    // Handle home page play buttons
  document.querySelectorAll('.play-button').forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      const wrapper = this.closest('.video-wrapper');
      const video = wrapper.querySelector('video');
      
      // Pause all other videos
      pauseAllVideosExcept(video);
      
      // Play video with sound
      video.muted = false;
        
        // Safari requires user interaction, ensure playsinline is set
        video.setAttribute('playsinline', 'true');
        video.setAttribute('webkit-playsinline', 'true');
        
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(() => {
        // Hide play button when video starts playing
        wrapper.classList.add('playing');
      }).catch(err => {
        console.error('Error playing video:', err);
            // On Safari, sometimes we need to try again
            setTimeout(() => {
              video.play().then(() => {
                wrapper.classList.add('playing');
              }).catch(() => {});
            }, 100);
          });
        }
      });
    });
    
    // Handle gallery page play buttons
    document.querySelectorAll('.astra-gallery__play-button').forEach(button => {
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        const wrapper = this.closest('.astra-gallery__video-wrapper');
        const video = wrapper.querySelector('.astra-gallery__video');
        const overlay = wrapper.querySelector('.astra-gallery__video-overlay');
        
        if (!video) return;
        
        // Pause all other videos
        pauseAllVideosExcept(video);
        
        // Play video with sound
        video.muted = false;
        
        // Safari requires user interaction, ensure playsinline is set
        video.setAttribute('playsinline', 'true');
        video.setAttribute('webkit-playsinline', 'true');
        
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(() => {
            // Hide overlay when video starts playing
            if (overlay) {
              overlay.style.opacity = '0';
              overlay.style.pointerEvents = 'none';
            }
          }).catch(err => {
            console.error('Error playing video:', err);
            // On Safari, sometimes we need to try again
            setTimeout(() => {
              video.play().then(() => {
                if (overlay) {
                  overlay.style.opacity = '0';
                  overlay.style.pointerEvents = 'none';
                }
              }).catch(() => {});
            }, 100);
          });
        }
    });
  });

  // Detect if we're on mobile
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 1024;

  // Hide play button when video is playing and pause others
  // Handle both home page videos (.video-wrapper video) and gallery videos (.astra-gallery__video)
  document.querySelectorAll('.video-wrapper video, .astra-gallery__video').forEach(video => {
    // Track if this is the first play (user-initiated)
    let isFirstPlay = true;
    
    video.addEventListener('play', function() {
      // Pause all other videos when this one starts playing
      pauseAllVideosExcept(this);
      
      // Automatically unmute when video starts playing (especially important on mobile)
      // This ensures videos play with sound when user clicks play
      if (this.muted && isFirstPlay) {
        this.muted = false;
        isFirstPlay = false;
      }
      
      const wrapper = this.closest('.video-wrapper') || this.closest('.astra-gallery__video-wrapper');
      if (wrapper) {
      wrapper.classList.add('playing');
      }
      
      // For gallery videos, hide overlay when playing
      const overlay = this.closest('.astra-gallery__item')?.querySelector('.astra-gallery__video-overlay');
      if (overlay && !this.muted) {
        overlay.style.opacity = '0';
        overlay.style.pointerEvents = 'none';
      }
    });
    
    video.addEventListener('pause', function() {
      const wrapper = this.closest('.video-wrapper') || this.closest('.astra-gallery__video-wrapper');
      if (wrapper) {
      wrapper.classList.remove('playing');
      }
      // Reset first play flag when video is paused, so next play will unmute again
      isFirstPlay = true;
    });
    
      // On mobile, also try to unmute when user interacts with video controls
      if (isMobile) {
        // Listen for volumechange to detect when user manually unmutes
        video.addEventListener('volumechange', function() {
          // If user manually unmuted, remember that
          if (!this.muted) {
            isFirstPlay = false;
          }
        });
        
        // Ensure video can receive touch events
        video.style.touchAction = 'manipulation';
        video.style.webkitTouchCallout = 'none';
      }
  });

  // DISABLED: Click-to-play functionality removed - videos only play via play button
  // Handle clicking on video to toggle play/pause
  // Use a map to track last toggle time per video to prevent double-toggling
  // const videoToggleTimes = new Map();
  
  // Handle home page video wrappers (including gallery hero videos)
  // DISABLED: Removed click-to-play - videos only play via play button
  // document.querySelectorAll('.video-wrapper').forEach(wrapper => {
  //   ... (click handlers removed)
  // });
  
  // Handle gallery page video wrappers
  // DISABLED: Removed click-to-play - videos only play via play button
  // document.querySelectorAll('.astra-gallery__video-wrapper').forEach(wrapper => {
  //   ... (click handlers removed)
  // });

  // Accordion functionality
  document.querySelectorAll('.accordion-item').forEach(item => {
    item.addEventListener('click', function() {
      const isActive = this.classList.contains('active');
      
      // Close all accordion items
      document.querySelectorAll('.accordion-item').forEach(accItem => {
        accItem.classList.remove('active');
      });
      
      // Toggle current item
      if (!isActive) {
        this.classList.add('active');
      }
    });
  });

  // FAQ functionality
  document.querySelectorAll('.faq-item').forEach(item => {
    item.addEventListener('click', function() {
      const isActive = this.classList.contains('active');
      
      // Close all FAQ items
      document.querySelectorAll('.faq-item').forEach(faqItem => {
        faqItem.classList.remove('active');
      });
      
      // Toggle current item
      if (!isActive) {
        this.classList.add('active');
      }
    });
  });

  // Scroll to payment section when CTA buttons are clicked
  function findPaymentSection() {
    // Try to find the astra-join section first (contains Buy with Shop button)
    const astraJoinSection = document.querySelector('.astra-join');
    if (astraJoinSection) {
      return astraJoinSection;
    }
    
    // Try to find featured product section (contains buy buttons)
    const featuredProductSection = document.querySelector('.featured-product, .section-featured-product');
    if (featuredProductSection) {
      return featuredProductSection;
    }
    
    // Try to find section containing the buy button
    const buyButton = document.querySelector('.astra-join__button, .shopify-payment-button, .product-form__buttons');
    if (buyButton) {
      const section = buyButton.closest('section');
      if (section) {
        return section;
      }
    }
    
    return null;
  }

  // Function to scroll to payment section
  function scrollToPaymentSection() {
    const paymentSection = findPaymentSection();
    if (paymentSection) {
      // Calculate offset to account for fixed header if any
      const headerOffset = 80;
      const elementPosition = paymentSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      return true;
    } else {
      console.warn('Payment section not found');
      return false;
    }
  }

  // Add click listeners to all CTA buttons
  const ctaButtons = document.querySelectorAll('.hero-cta, .slim-cta');
  ctaButtons.forEach(ctaButton => {
    ctaButton.addEventListener('click', function(e) {
      // Prevent default link behavior if it's an anchor tag
      if (this.tagName === 'A' && this.href && this.href !== '#' && !this.href.includes('javascript:')) {
        e.preventDefault();
      }
      
      // Scroll to the payment section
      scrollToPaymentSection();
    });
  });
});

